import axios from "axios";
import { initializeApp } from "firebase/app";
import {
  signInWithEmailAndPassword,
  getAuth,
  sendPasswordResetEmail,
} from "firebase/auth";
import FirebaseConfigByEnvironment from "../helpers/FirebaseHelper";

axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL;

const getHeader = (token) => {
  const accessToken = localStorage.getItem("token");

  return {
    authorization: accessToken ?? token,
  };
};

const getUser = (token) => {
  try {
    let response = axios.get("api/users", {
      headers: getHeader(token),
    });
    response.then(() => {});
    return response;
  } catch (e) {
    console.log(e);
  }
};

const login = async (email, password) => {
  try {
    const app = initializeApp(FirebaseConfigByEnvironment());
    const auth = getAuth(app);
    let firebaseUser = await signInWithEmailAndPassword(auth, email, password);
    let fireBaseUser = firebaseUser.user;
    let user = await getUser(fireBaseUser.accessToken);

    localStorage.setItem("token", fireBaseUser.accessToken);
    if (typeof user != "undefined" && user.hasOwnProperty("data")) {
      return { ...user.data, api_token: fireBaseUser.accessToken };
    } else return false;
  } catch (err) {
    console.error(err);
    return false;
  }
};

const resetPassword = async (email) => {
  const app = initializeApp(FirebaseConfigByEnvironment());
  const auth = getAuth(app);

  const response = await sendPasswordResetEmail(auth, email);

  return response;
};

export function getAllStrategies() {
  const response = axios.get("api/strategies", { headers: getHeader() });
  return response;
}

export function createStrategy(request) {
  const response = axios.post(
    "/api/strategies",
    {
      user_id: "6769b9ca310b6e812e873171",
      name: request.name,
      new_offer: request.new_offer,
      old_winner: request.old_winner,
      top_offer: request.top_offer,
    },
    { headers: getHeader() }
  );
  return response;
}

export function updateStrategy(request) {
  const response = axios.put(
    "/api/strategies/" + request?._id,
    {
      name: request.name,
      new_offer: request.new_offer,
      old_winner: request.old_winner,
      top_offer: request.top_offer,
    },
    { headers: getHeader() }
  );
  return response;
}

export function deleteStrategy(id) {
  const response = axios.delete("/api/strategies/" + id, {
    headers: getHeader(),
  });
  return response;
}

export function getAllOffers() {
  const response = axios.get("api/offers", { headers: getHeader() });
  return response;
}

export function getEverflowUnrecordedOffers(request = {}) {
  const params = new URLSearchParams();
  const page = request?.page != null ? request.page : 1;
  const limit = request?.limit != null ? request.limit : 50;
  params.append("page", page);
  params.append("limit", limit);
  const url =
    "/api/offers/everflow/unrecorded" +
    (params.toString() ? "?" + params.toString() : "");
  return axios.get(url, { headers: getHeader() });
}

export function getListicleCampaigns(request = {}) {
  const params = new URLSearchParams();
  const page = request?.page != null ? request.page : 1;
  const limit = request?.limit != null ? request.limit : 50;
  params.append("page", page);
  params.append("limit", limit);
  const url =
    "/api/offers/listicle/campaigns" +
    (params.toString() ? "?" + params.toString() : "");
  return axios.get(url, { headers: getHeader() });
}

export function getAllOffersV2(request) {
  const params = new URLSearchParams();

  if (request?.page !== null && request?.page !== undefined)
    params.append("page", request.page);
  if (request?.limit !== null && request?.limit !== undefined)
    params.append("limit", request.limit);
  if (request?.sortField !== null && request?.sortField !== undefined)
    params.append("sortField", request.sortField);
  if (request?.sortOrder !== null && request?.sortOrder !== undefined)
    params.append("sortOrder", request.sortOrder);
  if (
    request?.search !== null &&
    request?.search !== undefined &&
    request.search.trim() !== ""
  )
    params.append("search", request.search);
  if (request?.tagIds && request.tagIds.length > 0) {
    request.tagIds.forEach((id) => params.append("tag_ids", id));
  }
  if (
    request?.missingCreativeType === "SMS" ||
    request?.missingCreativeType === "Email"
  ) {
    params.append("missingCreativeType", request.missingCreativeType);
  }

  const url =
    "/api/offers/v2" + (params.toString() ? "?" + params.toString() : "");

  return axios.get(url, { headers: getHeader() });
}

export function getOfferSuggestions(request) {
  const params = new URLSearchParams();

  if (request?.page !== null && request?.page !== undefined)
    params.append("page", request.page);
  if (request?.limit !== null && request?.limit !== undefined)
    params.append("limit", request.limit);
  if (request?.status !== null && request?.status !== undefined)
    params.append("status", request.status);
  if (request?.sortBy !== null && request?.sortBy !== undefined)
    params.append("sortBy", request.sortBy);
  if (request?.sortOrder !== null && request?.sortOrder !== undefined)
    params.append("sortOrder", request.sortOrder);

  const url =
    "/api/offerSuggestions" +
    (params.toString() ? "?" + params.toString() : "");

  return axios.get(url, { headers: getHeader() });
}

export function getOfferSuggestionDetails(request) {
  const params = new URLSearchParams();
  if (request?.page !== null && request?.page !== undefined)
    params.append("page", request.page);
  if (request?.limit !== null && request?.limit !== undefined)
    params.append("limit", request.limit);

  const url =
    "/api/offerSuggestions/byOfferId/" +
    request?.offerId +
    (params.toString() ? "?" + params.toString() : "");

  return axios.get(url, { headers: getHeader() });
}

export function createOffer(request) {
  const response = axios.post(
    "/api/offers",
    {
      name: request.name,
      user_id: "6769b9ca310b6e812e873171",
      tag_ids: request.tags,
      link_type: request.linkType,
      link_id: request.linkId,
    },
    { headers: getHeader() }
  );
  return response;
}

export function updateOffer(request) {
  const response = axios.put(
    "/api/offers/" + request?._id,
    {
      name: request.name,
      user_id: "6769b9ca310b6e812e873171",
      tag_ids: request.tags,
      creative_ids: request.creativeIds,
      is_enabled: request.is_enabled,
      is_resolved: request.is_resolved,
      is_noted: request.is_noted,
      link_type: request.linkType,
      link_id: request.linkId,
    },
    { headers: getHeader() }
  );
  return response;
}

export function bulkDeleteOffers({ offer_ids, everflow_included }) {
  const response = axios.post(
    "/api/offers/bulk-delete",
    { offer_ids, everflow_included },
    { headers: getHeader() }
  );
  return response;
}

export function resetOfferScore(offerId) {
  return axios.post(
    "/api/offers/resetScore",
    { offer_id: offerId },
    { headers: getHeader() }
  );
}

export function boostOffer(offerId) {
  return axios.post(
    "/api/offers/boost",
    { offer_id: offerId },
    { headers: getHeader() }
  );
}

export function getAllCreatives() {
  const response = axios.get("/api/creatives", { headers: getHeader() });
  return response;
}

export function getAllCreativesV2(request) {
  const params = new URLSearchParams();

  if (request?.page !== null && request?.page !== undefined)
    params.append("page", request.page);
  if (request?.limit !== null && request?.limit !== undefined)
    params.append("limit", request.limit);
  if (request?.sortField !== null && request?.sortField !== undefined)
    params.append("sortField", request.sortField);
  if (request?.sortOrder !== null && request?.sortOrder !== undefined)
    params.append("sortOrder", request.sortOrder);
  if (request?.type !== null && request?.type !== undefined)
    params.append("type", request.type);
  if (request?.search !== null && request?.search !== undefined)
    params.append("search", request.search);
  if (request?.everflowMatched === true || request?.everflowMatched === false) {
    params.append(
      "everflowMatched",
      request.everflowMatched ? "true" : "false"
    );
  }

  const url =
    "/api/creatives/v2" + (params.toString() ? "?" + params.toString() : "");

  return axios.get(url, { headers: getHeader() });
}

export function createCreative(request) {
  const response = axios.post(
    "/api/creatives",
    {
      name: request.name,
      note: request.note,
      user_id: "6769b9ca310b6e812e873171",
      offer_id: request.offer_id,
      type: request.type,
    },
    { headers: getHeader() }
  );
  return response;
}

export function updateCreative(request) {
  const response = axios.put(
    "/api/creatives/" + request?._id,
    {
      user_id: "6769b9ca310b6e812e873171",
      name: request.name,
      note: request.note,
      offer_id: request.offer_id,
      type: request.type,
      is_resolved: request.is_resolved,
      is_noted: request.is_noted,
    },
    { headers: getHeader() }
  );
  return response;
}

export function deleteCreative(id) {
  const response = axios.delete("/api/creatives/" + id, {
    headers: getHeader(),
  });
  return response;
}

export function getAllTags() {
  const response = axios.get("/api/tags", { headers: getHeader() });
  return response;
}

export function createTag(request) {
  const response = axios.post(
    "/api/tags",
    {
      user_id: "6769b9ca310b6e812e873171",
      name: request.name,
    },
    { headers: getHeader() }
  );
  return response;
}

export function updateTag(request) {
  const response = axios.put(
    "/api/tags/" + request?._id,
    {
      name: request.name,
    },
    { headers: getHeader() }
  );
  return response;
}

export function deleteTag(id) {
  const response = axios.delete("/api/tags/" + id, { headers: getHeader() });
  return response;
}

export function getAllLists() {
  const response = axios.get("/api/lists", { headers: getHeader() });
  return response;
}

export function createList(request) {
  const response = axios.post(
    "/api/lists",
    {
      name: request.name,
      user_id: "6769b9ca310b6e812e873171",
      tag_ids: request.tags,
      slot: request.slot,
      type: request.type,
      strategy_id: request.strategy_id,
      ip_reputation: request.ip_reputation,
      domain_reputation: request.domain_reputation,
      segment: request.segment,
      from_name: request.from_name,
      is_active: request.is_active,
      note: request.note,
    },
    { headers: getHeader() }
  );
  return response;
}

export function updateList(request) {
  const response = axios.put(
    "/api/lists/" + request?._id,
    {
      name: request.name,
      user_id: "6769b9ca310b6e812e873171",
      tag_ids: request.tags,
      slot: request.slot,
      type: request.type,
      strategy_id: request.strategy_id,
      reputation: request.reputation,
      ip_reputation: request.ip_reputation,
      domain_reputation: request.domain_reputation,
      segment: request.segment,
      from_name: request.from_name,
      is_active: request.is_active,
      note: request.note,
    },
    { headers: getHeader() }
  );
  return response;
}

export function deleteList(id) {
  const response = axios.delete("/api/lists/" + id, { headers: getHeader() });
  return response;
}

export function getAllCalendar(date) {
  const response = axios.get(
    "/api/calendars?startDate=" +
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-01" +
      "&endDate=" +
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate(),
    { headers: getHeader() }
  );
  return response;
}

export function getSpecificCalendar(date) {
  const dayOfWeek = date.getDay();

  const startDate = new Date(date);
  const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
  startDate.setDate(date.getDate() + diffToMonday);
  startDate.setHours(0, 0, 1, 0);

  const endDate = new Date(startDate);
  endDate.setDate(startDate.getDate() + 6);
  endDate.setHours(23, 59, 59, 999);

  const response = axios.get(
    "/api/calendars?startDate=" +
      startDate.getFullYear() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getDate() +
      "&endDate=" +
      endDate.getFullYear() +
      "-" +
      (endDate.getMonth() + 1) +
      "-" +
      endDate.getDate(),
    { headers: getHeader() }
  );

  return response;
}

export function createCalendarManual(request) {
  const response = axios.post(
    "/api/calendars",
    {
      list_ids: request.list_ids,
      user_id: "6769b9ca310b6e812e873171",
      date: request.start_date,
      offer_id: request.offer_id,
      creative_id: request.creative_id,
    },
    { headers: getHeader() }
  );
  return response;
}

export function createCalendar(request) {
  const response = axios.post(
    "/api/calendars/generate",
    {
      list_ids: request.list_ids,
      user_id: "6769b9ca310b6e812e873171",
      number_of_days: parseInt(request.days),
      start_date: request.start_date,
    },
    { headers: getHeader() }
  );
  return response;
}

export function deleteCalendar(id) {
  const response = axios.delete("/api/calendars/" + id, {
    headers: getHeader(),
  });
  return response;
}

export function cancelCalendar(id, request) {
  const response = axios.patch(
    "/api/calendars/" + id + "/cancel",
    {
      cancel_reason_title: request.cancel_reason_title ?? "",
      cancel_reason_description: request.cancel_reason_description ?? "",
    },
    { headers: getHeader() }
  );
  return response;
}

export function deleteCalendarDate(date) {
  const response = axios.delete("/api/calendars/date/" + date, {
    headers: getHeader(),
  });
  return response;
}

export function updateRevenue(request) {
  const response = axios.patch(
    "/api/calendars/" + request?.id,
    {
      revenue: request.revenue,
      segment: request.segment,
      status: request.status,
    },
    { headers: getHeader() }
  );
  return response;
}

export function updateCalendarUrls(id, urls) {
  const response = axios.patch(
    "/api/calendars/" + id + "/url",
    { url: urls },
    { headers: getHeader() }
  );
  return response;
}

export function calculateScore(request) {
  const response = axios.post(
    "/api/calendars/" + request.id + "/calculateScore",
    { revenue: request.revenue },
    { headers: getHeader() }
  );
  return response;
}

export function getTopList(type) {
  const response = axios.get("/api/dashboard/topLists?type=" + type, {
    headers: getHeader(),
  });
  return response;
}

export function getTopOffers(type) {
  const params = type ? { type } : {};
  const response = axios.get("/api/dashboard/topOffers", {
    params,
    headers: getHeader(),
  });
  return response;
}

export function getPublicTopOffers() {
  // Public endpoint — intentionally called without auth headers
  const response = axios.get("/api/dashboard/public/topOffers");
  return response;
}

export function getLastMonthSummary() {
  const response = axios.get("/api/dashboard/lastMonthSummary", {
    headers: getHeader(),
  });
  return response;
}

export function getMonthlySummary() {
  const response = axios.get("/api/dashboard/monthlySummary", {
    headers: getHeader(),
  });
  return response;
}

export function getLastScheduledDate() {
  const response = axios.get("/api/calendars/lastExistingDate", {
    headers: getHeader(),
  });
  return response;
}

export function getWeeklyScores(id) {
  const response = axios.get("/api/offers/" + id + "/weekly-scores", {
    headers: getHeader(),
  });
  return response;
}

export function getSmsPricing() {
  return axios.get("/api/settings/sms-pricing", { headers: getHeader() });
}

export function createSmsPricing(request) {
  return axios.post(
    "/api/settings/sms-pricing",
    {
      cost_per_message: request.cost_per_message,
      notes: request.notes,
    },
    { headers: getHeader() }
  );
}

export function updateSmsPricing(request) {
  return axios.put(
    "/api/settings/sms-pricing/" + request?._id,
    {
      cost_per_message: request.cost_per_message,
      notes: request.notes,
    },
    { headers: getHeader() }
  );
}

export function deleteSmsPricing(id) {
  return axios.delete("/api/settings/sms-pricing/" + id, {
    headers: getHeader(),
  });
}

export function getPublicPageHiddenTags() {
  return axios.get("/api/settings/hidden-tags", {
    headers: getHeader(),
  });
}

export function updatePublicPageHiddenTags(request) {
  return axios.put(
    "/api/settings/hidden-tags",
    { tag_ids: request.tagIds ?? request.tag_ids ?? [] },
    { headers: getHeader() }
  );
}

export function getSmsAnalyticsSegmentList() {
  return axios.get("/api/smsAnalytics/segmentList", { headers: getHeader() });
}

export function getSmsAnalyticsOverviewHeader(request) {
  return axios.post("/api/smsAnalytics/overviewHeader", request, {
    headers: getHeader(),
  });
}

export function getSmsAnalyticsEngagementHeader(request) {
  return axios.post("/api/smsAnalytics/engagementHeader", request, {
    headers: getHeader(),
  });
}

export function getSmsAnalyticsRevenueByList(request) {
  return axios.post("/api/smsAnalytics/revenueByList", request, {
    headers: getHeader(),
  });
}

export function getSmsAnalyticsRevenueBySegment(request) {
  return axios.post("/api/smsAnalytics/revenueBySegment", request, {
    headers: getHeader(),
  });
}

export function getSmsAnalyticsTopCalendarByClick(request) {
  return axios.post("/api/smsAnalytics/topCalendarByClick", request, {
    headers: getHeader(),
  });
}

export function getSmsAnalyticsClicksByList(request) {
  return axios.post("/api/smsAnalytics/clicksByList", request, {
    headers: getHeader(),
  });
}

export function getSmsAnalyticsClicksBySegment(request) {
  return axios.post("/api/smsAnalytics/clicksBySegment", request, {
    headers: getHeader(),
  });
}

export function getSmsAnalyticsListPerformance(request) {
  return axios.post("/api/smsAnalytics/listPerformance", request, {
    headers: getHeader(),
  });
}

export function getSmsAnalyticsRevenueCostTrend(request) {
  return axios.post("/api/smsAnalytics/revenueCostTrend", request, {
    headers: getHeader(),
  });
}

export function getSmsAnalyticsClickConversionTrend(request) {
  return axios.post("/api/smsAnalytics/clickConversionTrend", request, {
    headers: getHeader(),
  });
}

export function getSmsAnalyticsCtrTrend(request) {
  return axios.post("/api/smsAnalytics/ctrTrend", request, {
    headers: getHeader(),
  });
}

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error && error.response && 403 === error.response.status) {
      logout();
      return;
    }
    return error.response;
  }
);

export function suggestCreative(offerId, type) {
  const body = type ? { type } : {};
  return axios.post(`/api/offers/${offerId}/suggest-creative`, body, {
    headers: getHeader(),
  });
}

export function approveCreative(offerId, data) {
  return axios.post(`/api/offers/${offerId}/approve-creative`, data, {
    headers: getHeader(),
  });
}

const logout = () => {
  localStorage.removeItem("token");
  localStorage.clear();
  document.location.reload();
};

export default {
  login,
  resetPassword,
  getUser,
  getAllStrategies,
  createStrategy,
  updateStrategy,
  deleteStrategy,
  getAllOffers,
  getEverflowUnrecordedOffers,
  getListicleCampaigns,
  getAllOffersV2,
  getOfferSuggestions,
  getOfferSuggestionDetails,
  createOffer,
  updateOffer,
  bulkDeleteOffers,
  resetOfferScore,
  boostOffer,
  suggestCreative,
  approveCreative,
  getAllCreatives,
  getAllCreativesV2,
  createCreative,
  updateCreative,
  deleteCreative,
  getAllTags,
  createTag,
  updateTag,
  deleteTag,
  getAllLists,
  createList,
  updateList,
  deleteList,
  getAllCalendar,
  createCalendar,
  updateRevenue,
  updateCalendarUrls,
  getTopList,
  getTopOffers,
  getPublicTopOffers,
  getLastMonthSummary,
  getMonthlySummary,
  deleteCalendar,
  cancelCalendar,
  createCalendarManual,
  calculateScore,
  deleteCalendarDate,
  getSpecificCalendar,
  getWeeklyScores,
  getSmsPricing,
  createSmsPricing,
  updateSmsPricing,
  deleteSmsPricing,
  getPublicPageHiddenTags,
  updatePublicPageHiddenTags,
  getSmsAnalyticsSegmentList,
  getSmsAnalyticsOverviewHeader,
  getSmsAnalyticsEngagementHeader,
  getSmsAnalyticsRevenueByList,
  getSmsAnalyticsRevenueBySegment,
  getSmsAnalyticsTopCalendarByClick,
  getSmsAnalyticsClicksByList,
  getSmsAnalyticsClicksBySegment,
  getSmsAnalyticsListPerformance,
  getSmsAnalyticsRevenueCostTrend,
  getSmsAnalyticsClickConversionTrend,
  getSmsAnalyticsCtrTrend,
};
